module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Gb-Hc-Ib-Jb.f1a8f2f1.png";